import React from 'react';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import DocumentationHome from './DocumentationHome';
import DocumentationPage from './DocumentationPage';

const DocumentationViews = ({ match }) => {
  return (
    <>
      <Switch>
        <Redirect exact path={`${match.url}/`} to={`${match.url}/1`} />
        <Route exact path={`${match.url}/`} component={DocumentationHome} />
        <Route exact path={`${match.url}/:id`} component={DocumentationPage} />
      </Switch>
    </>
  );
};

export default withRouter(DocumentationViews);
